import { gql } from "@apollo/client";

export const CAMPAIGN_ACTION_TRACK = gql`
  mutation CampaignActionTrack($input: CampaignActionTrackInput!) {
    campaignActionTrack(input: $input) {
      success
    }
  }
`;
